import Navbartop from "./navbar";
import Prosection from "./prosection";

export const Protab = () => {
  return (
    <section>
      <Navbartop />
      <Prosection />
    </section>
  )
}

export default Protab;